module.exports = __webpack_public_path__ + "static/media/exclamation-icon.f3cda292.svg";